import { Competition, PublicApiService } from "./publiApiService";
import { FishingDiscipline } from "../types/fishingDiscipline";

export interface UpcomingCompetition extends Competition {
  discipline: FishingDiscipline;
}

export async function getUpcomingCompetitions(
  discipline: FishingDiscipline,
  limit = 3,
  now = new Date()
): Promise<UpcomingCompetition[]> {
  const today = new Intl.DateTimeFormat("sv-SE", { timeZone: "Europe/Rome" }).format(now);
  let upcoming: UpcomingCompetition[] = [];
  let page = 1;

  // The existing API has no date filter. Stop when descending pages reach
  // past events, without downloading the historical archive.
  while (true) {
    const response = await PublicApiService.getCompetitions(page, 20, "CompetitionDate", true, discipline);
    const dated = response.results.filter(competition =>
      /^\d{4}-\d{2}-\d{2}/.test(competition.competitionDate) &&
      Number.isFinite(Date.parse(competition.competitionDate))
    );
    upcoming = [...upcoming, ...dated
      .filter(competition => competition.competitionDate.slice(0, 10) >= today && !competition.resultsPublished)
      .map(competition => ({ ...competition, discipline }))]
      .sort((a, b) => a.competitionDate.localeCompare(b.competitionDate) || a.id - b.id)
      .slice(0, limit);

    if (page >= response.totalPages || response.results.length === 0 ||
        dated.some(competition => competition.competitionDate.slice(0, 10) < today)) break;
    page += 1;
  }
  return upcoming;
}
